React = require 'react'
{ PropTypes } = React
{ connect } = require 'react-redux'
{ fetchDistricts, selectDistrict } = require '../actions/districts'
SelectDistrictComponent = require '../components/SelectDistrict'

SelectDistrict = React.createClass
	displayName: 'SelectDistrict'
	propTypes:
		disabled: PropTypes.bool
		districts: PropTypes.array
		feedback: PropTypes.object
		fetchDistricts: PropTypes.func.isRequired
		isFetching: PropTypes.bool
		reduxFormProps: PropTypes.object
		selectedDistrictId: PropTypes.number
		selectDistrict: PropTypes.func.isRequired
		# If this component shouldn't be responsible for fetching districts, set `shouldFetchDistricts` to false.
		# Defaults to true.
		shouldFetchDistricts: PropTypes.bool
		useLocalStorage: PropTypes.bool

	componentWillMount: ->
		unless @props.districts?.length || @props.shouldFetchDistricts == false
			@props.fetchDistricts()

	render: ->
		React.createElement(SelectDistrictComponent, { \
			"disabled": ( @props.disabled ),  \
			"districts": ( @props.districts ),  \
			"feedback": ( @props.feedback ),  \
			"isFetching": ( @props.isFetching ),  \
			"reduxFormProps": ( @props.reduxFormProps ),  \
			"selectedDistrictId": ( @props.selectedDistrict?.id ),  \
			"selectDistrict": ( @props.selectDistrict ),  \
			"useLocalStorage": ( @props.useLocalStorage )
		})

mapStateToProps = (state) ->
	districts: state.districts.list
	isFetching: state.districts.isFetching
	selectedDistrict: state.districts.selected

mapDispatchToProps = {
	fetchDistricts
	selectDistrict
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(SelectDistrict)



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/a2i/js/containers/SelectDistrict.cjsx